export { actions as implementations } from './action-implementations';
export { actions as definitions } from './action-definitions';
export const prefix = 'tpa/';
//# sourceMappingURL=index.js.map